export const AUTH_CONFIG = {
    clientId: 'fFfkrsrYm9UaoyaN5VY7pftV4JFAxGSE',
    domain: 'wyshpo.auth0.com',
    callbackUrl: `${window.location.protocol}//${window.location.host}/callback`,
    apiUrl: 'API_IDENTIFIER'
}



// WEBPACK FOOTER //
// ./src/auth0/auth0-variables.js